import { useQuery } from "@tanstack/react-query";

import { LoadingState } from "@/components/loading-state";
import { StatCard } from "@/components/stat-card";
import { apiGet } from "@/lib/api-client";
import { asCurrency, asPercent } from "@/lib/format";

interface PortfolioPayload {
  success?: boolean;
  snapshot?: {
    cash: number;
    positions_value: number;
    total_value: number;
    total_pnl: number;
    open_positions: number;
    closed_positions: number;
    win_rate: number | null;
  } | null;
}

export function PortfolioCard() {
  const { data, isLoading, error } = useQuery({
    queryKey: ["paper-portfolio-card"],
    queryFn: () => apiGet<PortfolioPayload>("/api/paper/portfolio"),
    refetchInterval: 30_000,
  });

  if (isLoading) return <LoadingState text="Loading portfolio..." />;
  if (error || data?.success === false || !data?.snapshot) {
    return <p className="text-sm text-red-400">Portfolio unavailable</p>;
  }

  const { snapshot } = data;

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      <StatCard label="Cash" value={asCurrency(snapshot.cash)} />
      <StatCard label="Open Positions" value={String(snapshot.open_positions)} />
      <StatCard label="Total PnL" value={asCurrency(snapshot.total_pnl)} />
      <StatCard label="Win Rate" value={snapshot.win_rate == null ? "n/a" : asPercent(snapshot.win_rate)} />
    </div>
  );
}
